module.exports = __webpack_public_path__ + "static/assets/e8a155d8150b529fd7d5324ce471a3d2.svg";